import { CountryBackgroundImage } from './CountryBackgroundImage';

export default CountryBackgroundImage;
